import { render } from "./Foot.vue?vue&type=template&id=19983ae0&scoped=true"
import script from "./Foot.vue?vue&type=script&lang=js"
export * from "./Foot.vue?vue&type=script&lang=js"

import "./Foot.vue?vue&type=style&index=0&id=19983ae0&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-19983ae0"

export default script